import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { env } from '../../../app.constant';
import { tap } from 'rxjs/operators';
import { ManageApiResponse, ManageBudgetAccount, MgtBgtAcctGetListsParams, MgtBgtAcctSave, MgtBgtAcctUpdate } from '../../data/system/manageBudgetAccount';

@Injectable()
export class ManageBudgetAccountService extends ManageBudgetAccount {

  constructor(private http: HttpClient) { super(); }

  getLists(params: MgtBgtAcctGetListsParams): Observable<ManageApiResponse> {
    const host = `${env.host}${env.endpoint.manage_budget_account_get_list.replace(':major', params.major).replace(':sub_major', params.sub_major).replace(':ledger', params.ledger).replace(':sub_obj', params.sub_obj)}`;
    return this.http.get<ManageApiResponse>(host).pipe(tap(data => console.log(`manage_budget_account->getLists()->data`, data)));
  }

  save(params: MgtBgtAcctSave): Observable<ManageApiResponse> {
    const host = `${env.host}${env.endpoint.manage_budget_account_save}`;
    return this.http.post<ManageApiResponse>(host, params).pipe(tap(data => console.log(`manage_budget_account->save()->data`, data)));
  }

  delete(id: string | number) {
    const host = `${env.host}${env.endpoint.manage_budget_account_delete.replace(':id', id)}`;
    return this.http.delete<ManageApiResponse>(host).pipe(tap(data => console.log(`manage_budget_account->delete()->data`, data)));
  }

  update(params: MgtBgtAcctUpdate): Observable<ManageApiResponse> {
    const host = `${env.host}${env.endpoint.manage_budget_account_update}`;
    return this.http.put<ManageApiResponse>(host, params).pipe(tap(data => console.log(`manage_budget_account->update()->data`, data)));
  }

}
